module.exports = require("@bechtel/client-assets/dist/images/empty-rod-detail.svg");